import { ApiService } from "services/Api.service";

import { User, UserDTO } from "models/user/User";

export class UserService {
  private _apiService: ApiService;

  private _user: User | null = null;

  constructor(apiService: ApiService) {
    this._apiService = apiService;
  }

  public get user() {
    return this._user;
  }

  public async fetchDetails() {
    const user = new User({
      email: "user@user.com",
      roles: ["ADMIN_ROLE"],
      profiles: [{ id: 1, nickname: "admin" }]
    });

    this._user = user;

    return Promise.resolve(user);
    // eslint-disable-next-line
    return await this._apiService
      .get<UserDTO>("/overmind/user/details")
      .then(user => new User(user))
      .then(user => (this._user = user));
  }
}
